import { fb, validators } from 'form';

export function getStoreEditModel(data) {
  const model = fb.group({
    storeName: [data.storeName || '', [validators.Required()], { type: 'text' }],
  })

  return model;
}
